export default "__VITE_ASSET__aZZ4_ryE__$_?url__"